import React, { Component } from 'react';
import classNames from "classnames";

class Option extends Component {
    render() {
        const classname = classNames("text-option-list", {
            "text-option-choosen": this.props.userOption === this.props.id
        });
        const { text, id, index, userClickedOnOption } = this.props;
        return (
            <div
                onClick={() => {
                    userClickedOnOption && userClickedOnOption(id)
                }}
                id={`tutorial-call-step-${index}`}
                className={classname}
            >
                <span className="chat-text">{text}</span>
            </div>
        );
    }
}

export default Option;



// WEBPACK FOOTER //
// /src/call/container/mcq/option/option.js